// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

let headers = ''

function headersSet() {
  const headersQ = window.localStorage.getItem('Headers')
  headers = JSON.parse(headersQ)
}


export const getSubCompanyList = createAsyncThunk('Client/getSubCompanyList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetSubCompanyList')
  return response.data
})

export const getPriorityLst = createAsyncThunk('client/getPriorityList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetPriorityList')
  return response.data
})
export const getInvoicePeriodList = createAsyncThunk('Client/getInvoicePeriodList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetInvoicePeriodList')
  return response.data
})
export const StripeKey = createAsyncThunk('appCardtransactions/StripeKey', async (GetCCDetails) => {
  const response = await axios.post('https://api.zasway.com:8443/Configuration/GetStripeKeyLive', GetCCDetails, { mode: 'cors' })
  return response.data
})
export const getInvoiceSplitList = createAsyncThunk('Client/getInvoiceSplitList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetInvoiceSplitList')
  return response.data
})

export const getInvoiceGroupList = createAsyncThunk('Client/getInvoiceGroupList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetInvoiceGroupList')
  return response.data
})

export const getTaxList = createAsyncThunk('Client/getTaxList', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetTaxList', params, { mode: 'cors' })
  return response.data
})

export const getPaymentMethodList = createAsyncThunk('Client/getPaymentMethodList', async (params) => {
  const companyID = JSON.parse(localStorage.getItem('companyID')) || 0
  const response = await axios.post('https://api.zasway.com:8443/Common/GetPaymentMethodList', params || { companyID })
  return response.data
})

export const getVehicleTypeList = createAsyncThunk('Client/getVehicleTypeList', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetVehicleTypeList', params, { mode: 'cors' })
  return response.data
})

export const getCurrencyList = createAsyncThunk('Client/getCurrencyList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetCurrencyList')
  return response.data
})

export const getPricingModalList = createAsyncThunk('Client/getPricingModalList', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetPricingModalList', params, { mode: 'cors' })
  return response.data
})

export const getPricingModeList = createAsyncThunk('Client/getPricingModeList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetPricingModeList')
  return response.data
})

export const getGraceWaitingList = createAsyncThunk('Client/getGraceWaitingList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetGraceWaitingList')
  return response.data
})
export const getClientImage = createAsyncThunk('appDriver/GetClientImage', async (client) => {

  const response = await axios.post('https://api.zasway.com:8443/Common/GetClientImage', client, { mode: 'cors' })
  return response.data
})
export const UploadImage = createAsyncThunk('appDriver/UploadImage', async (formData) => {

  const response = await axios.post('https://api.zasway.com:8443/Common/UploadImageClient', formData, { mode: 'cors' })

  return response
})

export const getBookingStatusList = createAsyncThunk('Client/getBookingStatusList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetBookingStatusList')
  return response.data
})

export const getClientTypeList = createAsyncThunk('Client/getClientTypeList', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Client/GetClientTypeList', params, { mode: 'cors' })
  return response.data
})

export const getConfirmationSMSList = createAsyncThunk('Client/getConfirmationSMSList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Client/GetConfirmationSMSList')
  return response.data
})

export const getConfirmationEmailList = createAsyncThunk('Client/getConfirmationEmailList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Client/GetConfirmationEmailList')
  return response.data
})

export const getOnRouteSmsList = createAsyncThunk('Client/getOnRouteSmsList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Client/GetOnRouteSmsList')
  return response.data
})

export const getAssignedSMSList = createAsyncThunk('Client/getAssignedSMSList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Client/GetAssignedSMSList')
  return response.data
})

export const getAssignedEmailList = createAsyncThunk('Client/getAssignedEmailList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Client/GetAssignedEmailList')
  return response.data
})

export const getCoaSMSList = createAsyncThunk('Client/getCoaSMSList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Client/GetCoaSMSList')
  return response.data
})

export const getArrivalSMSList = createAsyncThunk('Client/getArrivalSMSList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Client/GetArrivalSMSList')
  return response.data
})

export const getArrivalPhoneCallList = createAsyncThunk('Client/getArrivalPhoneCallList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Client/GetArrivalPhoneCallList')
  return response.data
})

export const getCompletionSMSList = createAsyncThunk('Client/getCompletionSMSList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Client/GetCompletionSMSList')
  return response.data
})

export const getRepList = createAsyncThunk('Client/getRepList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Client/GetRepList')
  return response.data
})

export const getClientTagList = createAsyncThunk('Client/getClientTagList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Client/GetClientTagList')
  return response.data
})

export const addClient = createAsyncThunk('Client/Create', async (Client) => {

  headersSet()
  const response = await axios.post('https://api.zasway.com:8443/Client/Create', Client, { headers }, { mode: 'cors' })

  if (response.data.code === undefined || response.data.code === 200) {
    return {
      data: response
    }
  } else {
    return {
      data: response.data.code
    }
  }
  // return response
})

export const getClientUsersList = createAsyncThunk('Client/getDriverUsersList', async (params) => {

  const response = await axios.post('https://api.zasway.com:8443/Client/GetClientListForParents', params, { mode: 'cors' })

  return response.data
})
export const getDocumentTypeList = createAsyncThunk('appDriver/getDocumentTypeList', async (OwnerType) => {

  const response = await axios.post('https://api.zasway.com:8443/Common/GetDocumentTypeList', OwnerType, { mode: 'cors' })

  return response.data
})
export const deleteDocument = createAsyncThunk('appDriver/DeleteDocument', async (id) => {

  const response = await axios.post('https://api.zasway.com:8443/Common/DeleteDocument', id, { mode: 'cors' })
  return response
})
export const EditDocument = createAsyncThunk('appDriver/UpdateDocument', async (formData) => {
  let flag = 0

  const response = await axios.post('https://api.zasway.com:8443/Common/UpdateDocument', formData, { mode: 'cors' })

  if (response.data.code === 200) { flag = 1 }
  return {
    response,
    isSaved: flag
  }
})
export const getDocument = createAsyncThunk('appDriver/getDocument', async (Doc) => {

  const response = await axios.post('https://api.zasway.com:8443/Common/GetDocument', Doc, { mode: 'cors' })
  return response.data
})
export const addDocument = createAsyncThunk('appDriver/CreateDocument', async (formData) => {

  let flag = 0
  const response = await axios.post('https://api.zasway.com:8443/Common/Create', formData, { mode: 'cors' })
  if (response.data.code === 200) { flag = 1 }
  return {
    response,
    isSaved: flag
  }
})

export const resetFlag = createAsyncThunk('appDriver/ResetFlag', () => {

  return { isSaved: 0 }
})
export const GetDocumentDetailsByOwnerType = createAsyncThunk('appDriver/GetDocumentDetailsByOwner', async (Owner) => {

  const response = await axios.post('https://api.zasway.com:8443/Common/GetDocumentSummaryByOwnerType', Owner, { mode: 'cors' })

  return response.data
})
export const GetDocumentDetailsByID = createAsyncThunk('appDriver/GetDocumentDetailsByID', async (document) => {

  const response = await axios.post('https://api.zasway.com:8443/Common/GetDocumentDetailByID', document, { mode: 'cors' })

  return response.data
})
export const EditClient = createAsyncThunk('Client/Update', async (Client) => {

  headersSet()
  const response = await axios.post('https://api.zasway.com:8443/Client/Update', Client, { headers }, { mode: 'cors' })

  if (response.data.code === undefined || response.data.code === 200) {
    return {
      data: response
    }
  } else {
    return {
      data: response.data.code
    }
  }
  // return response
})
export const addClientchild = createAsyncThunk('Client/Create', async (Client) => {


  headersSet()
  const response = await axios.post('https://api.zasway.com:8443/Client/CreateChild', Client, { headers }, { mode: 'cors' })

  if (response.data.code === undefined || response.data.code === 200) {

    return {
      data: response
    }
  } else {
    return {
      data: response.data.code
    }
  }
  // return response
})
export const addClientchildArray = createAsyncThunk('Client/Create', async (Client) => {

  console.log('ok')
  headersSet()
  const response = await axios.post('https://api.zasway.com:8443/Client/CreateChildArray', Client, { headers }, { mode: 'cors' })

  if (response.data.code === undefined || response.data.code === 200) {

    return {
      data: response
    }
  } else {
    return {
      data: response.data.code
    }
  }
  // return response
})


// export const getData = createAsyncThunk('Client/getData', async (params) => {

//   headersSet()
//   const response = await axios.post('https://api.zasway.com:8443/Client/GetTableSummary', params, { headers }, { mode: 'cors' })

//   if (response.data.code === undefined) {
//     return {
//       params,
//       data: response.data.data,
//       allData: response.data.allData,
//       totalPages: response.data.total
//     }
//     // return response
//   })


  export const getAllData = createAsyncThunk('Client/GetTableSummary', async (GetClient) => {
     
  const response = await axios.post('https://api.zasway.com:8443/Client/GetTableSummary', GetClient, {mode:'cors'})
    
  return response.data
  })

  export const getClientBookers = createAsyncThunk('Client/getClientBookers', async (params) => {
    headersSet()
    const response = await axios.post('https://api.zasway.com:8443/Client/GetClientBookers', params, {headers}, {mode:'cors'})
    if (response.data.code === undefined || response.data.code === 200) {
      return {
        data: response.data.allData
      }
    } else {
      return { data: response.data.code }
    }
  })

  export const getData = createAsyncThunk('Client/getData', async (params) => {
       
    headersSet()
    const response = await axios.post('https://api.zasway.com:8443/Client/GetTableSummary', params, {headers}, {mode:'cors'})
      
    if (response.data.code === undefined) {
      return {
        params,
        data: response.data.data,
        allData: response.data.allData,
        totalPages: response.data.total
      }
    } else {
      return {
        data : response.data.code
      }
    }
  })

export const getClient = createAsyncThunk('Client/getClient', async (params) => {

  const response = await axios.post('https://api.zasway.com:8443/Client/GetTableSummary', params, { mode: 'cors' })

  return {
    params,
    data: response.data.data,
    allData: response.data.allData,
    totalPages: response.data.total
  }
})
export const getUser = createAsyncThunk('appUsers/getUser', async () => {

  const response = await axios.get('https://api.zasway.com:8443/Vendor/GetVendorList', data)
  return response.data
})

export const addUser = createAsyncThunk('appUsers/addUser', async (user, { dispatch, getState }) => {

  await axios.post('https://api.zasway.com:8443/User/CreateUser', user, { mode: 'cors' })
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return user
})

export const deleteClient = createAsyncThunk('Client/Delete', async (id, { dispatch, getState }) => {

  headersSet()
  const response = await axios.post('https://api.zasway.com:8443/Client/Delete', id, { headers }, { mode: 'cors' })
  await dispatch(getData(getState().clients.params))

  if (response.data.code === undefined || response.data.code === 200) {
    return {
      data: response
    }
  } else {
    return {
      data: response.data
    }
  }
  // return response
})
export const getUserbyStaff = createAsyncThunk('Client/getRepList', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetUserByStaffForRep', params, { mode: 'cors' })
  return response.data
})
export const GetTopClient = createAsyncThunk('Client/GetTopClient', async (GetClient) => {

  const response = await axios.post('https://api.zasway.com:8443/Client/GetTopClient', GetClient, { mode: 'cors' })

  return response.data
})
export const getClientStats = createAsyncThunk('Client/GetClientStatistics', async (GetClient) => {

  const response = await axios.post('https://api.zasway.com:8443/Client/GetClientStatistics', GetClient, { mode: 'cors' })

  return response.data
})
export const getClientBookingCount = createAsyncThunk('Client/GetClientBookingCount', async (GetClient) => {

  const response = await axios.post('https://api.zasway.com:8443/Client/GetClientBookingCount', GetClient, { mode: 'cors' })

  return response.data
})

export const getClientWeekDays = createAsyncThunk('Client/getClientWeekDays', async (GetWDDetails) => {
  const response = await axios.post('https://api.zasway.com:8443/Client/GetClientWeekDays', GetWDDetails, { mode: 'cors' })
  return {
    data: response.data
  }
})

export const getClientBookingTrends = createAsyncThunk('Client/getClientBookingTrends', async (GetBTDetails) => {

  const response = await axios.post('https://api.zasway.com:8443/Client/GetClientBookingTrends', GetBTDetails, { mode: 'cors' })

  return {
    data: response.data
  }
})

export const getAllBookingTrends = createAsyncThunk('Client/getAllBookingTrends', async (GetBTDetails) => {

  const response = await axios.post('https://api.zasway.com:8443/Common/GetAllBookingTrends', GetBTDetails, { mode: 'cors' })

  return {
    data: response.data
  }
})

export const ClientSlice = createSlice({
  name: 'client',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null,
    selectedDocument: [],
    ClientWeekDaysData: [],
    ClientBookingTrends: [],
    AllBookingTrends: [],
    IsSaved: 0
  },
  reducers: {},
  extraReducers: builder => {
    builder

      .addCase(getClientWeekDays.fulfilled, (state, action) => {
        state.ClientWeekDaysData = action.payload.data
      })

      .addCase(getClientBookingTrends.fulfilled, (state, action) => {

        state.ClientBookingTrends = action.payload.data
      })

      .addCase(getAllBookingTrends.fulfilled, (state, action) => {

        state.AllBookingTrends = action.payload.data
      })

      .addCase(getAllData.fulfilled, (state, action) => {

        state.allData = action.payload
      })
      .addCase(getData.fulfilled, (state, action) => {

        state.data = action.payload.data
        state.params = action.payload.params
        state.allData = action.payload.allData
        state.total = action.payload.totalPages
      })
      .addCase(getUser.fulfilled, (state, action) => {

        state.selectedUser = action.payload
      })
      .addCase(getClient.fulfilled, (state, action) => {

        state.selectedUser = action.payload.allData[0]
      })
      .addCase(GetDocumentDetailsByID.fulfilled, (state, action) => {

        state.selectedDocument = action.payload
      })
      .addCase(addDocument.fulfilled, (state, action) => {

        state.IsSaved = action.payload.isSaved
      })
      .addCase(EditDocument.fulfilled, (state, action) => {

        state.IsSaved = action.payload.isSaved
      })
      .addCase(resetFlag.fulfilled, (state, action) => {

        state.IsSaved = action.payload.isSaved
      })
  }
})


export default ClientSlice.reducer
